import { render, staticRenderFns } from "./ProcesoValidaciones.vue?vue&type=template&id=1dca47c1&"
import script from "./ProcesoValidaciones.vue?vue&type=script&lang=js&"
export * from "./ProcesoValidaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports